module.exports = __webpack_public_path__ + "img/garden.bcc8436e.webp";